import {mapInstruction} from './normalizeSections';

export default (sections, instruction) => {
	const normalizedInstruction = mapInstruction(instruction, instruction.sectionId);
	return sections.map((sec) => {
		if (sec.id === normalizedInstruction.sectionId) {
			const updatedInstructions = sec.instructions.map((instruction) => {
				if (instruction.id === normalizedInstruction.id) return normalizedInstruction;
				return instruction;
			});
			return {...sec, instructions: updatedInstructions};
		}
		return sec;
	});
};
